import { Directive, ElementRef, Input, TemplateRef, ViewContainerRef } from '@angular/core';
import { UserConfigService } from '../services/user-config.service';

@Directive({
  selector: '[appUserProfile]'
})
export class UserProfileDirective {

  constructor(el: ElementRef, private templateRef: TemplateRef<any>,
              private viewContainer: ViewContainerRef, private userConfig: UserConfigService) { }

  @Input() set appUserProfile(profile: [string, string, string]) {
    const profileName = profile[0];
    const profileKey = profile[1];
    const profileValue = profile[2];
    let hide = true;
    const userProfileValue = this.userConfig.profileValue(profileName, profileKey);
    if (userProfileValue) {
      if (userProfileValue === profileValue) {
        hide = false;
      }
    }
    if (hide){
      // Remove this dom element
      this.viewContainer.clear();
    } else {
      this.viewContainer.createEmbeddedView(this.templateRef);
    }
  }
}
